import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  defaultBtn: {
    "&.Mui-disabled": {
      color: "#fff",
      background: "#bbb",
    },
    textTransform: "none",
    fontSize: "16px",
    padding: "6.5px 20px",
    borderRadius: "50px",
    background: "white",
    color: "#6C6B6B",

    "&:hover": {
      background: "white",
      color: "#c4c4c4",
    },

    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
      padding: "6.5px 5px",
    },
  },
  primaryBtn: {
    textTransform: "none",
    color: "white",
    fontSize: "16px",
    background: "linear-gradient(90deg, #03D9B1 0%, #1CBBD9 100%)",
    borderRadius: "50px",
    width: "auto",
    padding: "6.5px 20px",

    "&:hover": {
      background: "linear-gradient(90deg, #06C9A4 0%, #00A2C1 100%)",
      color: "#FFFFFF",
    },

    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
      width: "auto",
      padding: "6.5px 5px",
    },
    "&.Mui-disabled": {
      color: "#fff",
      background: "#bbb",
    },
  },
  headerTitle: {
    display: "flex",
    alignItems: "center",

    "& svg": {
      height: "24px",
      marginRight: "8px",
      fill: "#fff",
    },
  },
}));
